import { render, staticRenderFns } from "./u-table-line.vue?vue&type=template&id=d80c62d2&scoped=true&"
import script from "./u-table-line.vue?vue&type=script&lang=js&"
export * from "./u-table-line.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80c62d2",
  null
  
)

export default component.exports